import { IconCloudArrowUp, IconMagnifyingGlass } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import styles from '../styles.module.css'
import { PickerTabItem } from './PickerTabItem'
import { PickerMode } from './types'

export const PickerTabs: React.FC<{
  mode: PickerMode
  onChange: (mode: PickerMode) => void
}> = ({ mode, onChange }) => {
  const { t } = useAPPTranslation()

  return (
    <div
      className={styles.modeTabs}
      role="tablist"
      aria-label={t('rm:advertiserProducts.addModal.title')}
    >
      <PickerTabItem
        active={mode === 'search'}
        icon={<IconMagnifyingGlass width={16} height={16} />}
        label={t('rm:advertiserProducts.addModal.tab.search')}
        onClick={() => onChange('search')}
      />
      <PickerTabItem
        active={mode === 'batch'}
        icon={<IconCloudArrowUp width={16} height={16} />}
        label={t('rm:advertiserProducts.addModal.tab.batch')}
        onClick={() => onChange('batch')}
      />
    </div>
  )
}
